module.exports = __webpack_public_path__ + "img/white-clock.2f7f412d.svg";